/**
 * The boot splash is markup in index.html, so it paints from the HTML alone —
 * before this bundle exists. React hands the screen over once it has mounted.
 */
export function dismissSplash() {
  const splash = document.getElementById("splash");
  if (!splash) return;

  splash.classList.add("splash--done");
  // Remove on the fade's own event, with a timer behind it for the cases where
  // `transitionend` never fires (reduced motion, a backgrounded tab).
  splash.addEventListener("transitionend", () => splash.remove(), { once: true });
  window.setTimeout(() => splash.remove(), 600);
}
